import { createReducer, updateDeepState } from '../handlers'
import types from './types'

const initialState = {
  
}

const update = (state, action) => {
  return updateDeepState(state, action.buttons)
}

export default createReducer(initialState, {
  [types.update]: update,
})